import type { RouteObject } from "react-router";
import { INVITE_ROUTES } from "../constants/invite-routes";

export const inviteRouter: RouteObject = {
	children: [
		{
			path: INVITE_ROUTES.INVITE,
			lazy: async () => {
				const { default: InvitePage } = await import("../pages/invite-page");
				return { Component: InvitePage };
			},
		},
	],
};
